var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import Select from '../../../../Elements/Select/Select';
import { Paragraph4 } from '../../../../Elements/Typography/Typography';
import { rowsPerPageOptions } from '../../utils/constants';
import { Trans } from '@lingui/react';
import styled, { x } from '@xstyled/styled-components';
var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  & > :nth-child(2) {\n    display: none;\n    @media (min-width: 1024px) {\n      display: block;\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  & > :nth-child(2) {\n    display: none;\n    @media (min-width: 1024px) {\n      display: block;\n    }\n  }\n"])));
var StyledSelect = styled(x.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 15px;\n  @media (min-width: 1024px) {\n    margin-right: 8px;\n  }\n"], ["\n  margin-right: 15px;\n  @media (min-width: 1024px) {\n    margin-right: 8px;\n  }\n"])));
var TablePagination = function (_a) {
    var gridActions = _a.gridActions, gridSelectors = _a.gridSelectors, autoRowsPerPage = _a.autoRowsPerPage, customPaginationHandler = _a.customPaginationHandler;
    var setRowsPerPage = gridActions.setRowsPerPage;
    var page = gridSelectors.page;
    var rowsPerPage = gridSelectors.rowsPerPage || 10;
    var options = useMemo(function () {
        return autoRowsPerPage
            ? __spreadArray(__spreadArray([], rowsPerPageOptions, true), [{ value: autoRowsPerPage, label: "auto (".concat(autoRowsPerPage, ")") }], false) : rowsPerPageOptions;
    }, [autoRowsPerPage]);
    var onSetRowsPerPage = useCallback(function (option) {
        if (option && 'value' in option) {
            var value = Number(option.value);
            setRowsPerPage === null || setRowsPerPage === void 0 ? void 0 : setRowsPerPage(value);
            customPaginationHandler === null || customPaginationHandler === void 0 ? void 0 : customPaginationHandler(page !== null && page !== void 0 ? page : 1, value);
        }
    }, [setRowsPerPage, page, customPaginationHandler]);
    return (_jsxs(Wrapper, { children: [_jsx(StyledSelect, { minWidth: "110px", children: _jsx(Select, { name: "rowsPerPage", menuPlacement: "top", style: "gridFilter", placeholder: "".concat(rowsPerPage), options: options, value: rowsPerPage, isDarkPlaceholderText: true, onChange: onSetRowsPerPage }) }), _jsx(Paragraph4, { variant: "normal", mr: "20px", children: _jsx(Trans, { id: "dataGrid.resultsPerPage", message: "Results per page" }) })] }));
};
export default TablePagination;
var templateObject_1, templateObject_2;
